<template>
  <v-card class="mx-auto" elevation="2">
    <app-card-header
      icon="mdi-account"
      :text="siteText.ui.applicantInformation"
      class="controlled-font"
    ></app-card-header>
    <v-card-text class="mx-auto">
      <v-row flex class="pt-5 mx-10">
        <v-col sm="2">
          <v-img
            v-show="displayExamineeImage"
            class="rounded applicant-image"
            :src="applicantPhoto"
          >
          </v-img>
        </v-col>
        <v-col sm="10">
          <v-simple-table dense class="pt-10">
            <thead>
              <tr>
                <th class="font-weight-bold text-left controlled-font">
                  {{ siteText.ui.applicant }}
                </th>
                <th class="font-weight-bold text-left controlled-font">
                  {{ siteText.ui.zipCode }}
                </th>
                <th class="font-weight-bold text-left controlled-font">
                  {{ siteText.ui.officeName }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-left controlled-font">
                  {{ userDetails.fullName }}
                </td>
                <td class="text-left controlled-font">
                  {{ userDetails.zipCode }}
                </td>
                <td class="text-left controlled-font">{{ officeName }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <div class="controlled-font mb-5 pt-10" v-html="messageText"></div>
          <div
            class="controlled-font mb-5 pt-1"
            v-html="messageTextEx"
            v-show="messageTextEx"
          ></div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import appCardHeader from "./ui/CardHeader.vue";
export default {
  components: {
    appCardHeader,
  },
  props: {
    message: String,
    messageEx: String,
    displayExamineeImage: Boolean,
  },
  data() {
    return {
      NoImage: require("../assets/images/generic_user_image.png"),
    };
  },
  computed: {
    ...mapGetters(["userDetails", "siteText", "officeName", "baseApiUrl"]),
    messageText() {
      return this.message;
    },
    messageTextEx() {
      return this.messageEx;
    },
    applicantPhoto() {
      return this.userDetails.photoId
        ? `${this.baseApiUrl}Documents/ApplicantImage/${this.userDetails.photoId}`
        : this.NoImage;
    },
  },
};
</script>

<style scoped>
th,
td {
  border: none !important;
  color: black !important;
}
.applicant-image {
  max-width: 125px;
}
.v-chip {
  min-width: 250px !important;
}

.v-expansion-panel-header {
  color: white;
}

.v-card__text {
  color: black !important;
}
</style>
